<template>
    <div v-if="title || perex" class="info-text">
        <h2 class="info-text__title" v-if="title">
            <DsIcon
                class="info-text__title-arrow"
                :width="22"
                :height="22"
                v-if="showBackLink"
                name="arrow-right"
                @click="goBack()"
            />
            <span class="info-text__title-text" v-html="title"></span>
        </h2>
        <div class="info-text__perex" v-if="perex" v-html="perex"></div>
    </div>
</template>

<script setup lang="ts">
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";

defineProps<{
    title?: string;
    perex?: string;
    showBackLink?: boolean;
}>();

const emit = defineEmits(["prevStep"]);

const goBack = () => {
    emit("prevStep");
};
</script>
